// import { apiSlice } from '@/store/api/apiSlice';
// import { getWeeklyDateRange } from '@/utils/getWeeklyDateRange';

// export interface SignChangeAspect {
//   sign: string;
//   from: string;
//   to: string;
//   house: number;
//   aspects: {
//     aspect: number[];
//     aspectSigns: string[];
//     houseAspect: number[];
//   };
// }

// export interface NakshatraItem {
//   nakshatra: string;
//   timestamp: string;
// }

// export interface PadaItem {
//   nakshatra: string;
//   pada: string;
//   timestamp: string;
// }

// export interface AstaItem {
//   startTime: string;
//   endTime: string;
//   totalDuration: string;
// }

// export interface VakriItem {
//   retrogradeTime: string;
//   progressiveTime: string;
//   totalRetrograde: string;
// }

// export interface WeeklyTransit {
//   signChangesAspect: SignChangeAspect[];
//   nakshtra: NakshatraItem[];
//   pada: PadaItem[];
//   asta: AstaItem[];
//   vakri: VakriItem[];
// }

// export interface WeeklyTransitWithAspectResponse {
//   planet: string;
//   weeklyTransit: WeeklyTransit[];
// }

// export const weeklyTransitWithAspectApi = apiSlice.injectEndpoints({
//   endpoints: (builder) => ({
//     getWeeklyTransitWithAspect: builder.query<
//       WeeklyTransitWithAspectResponse[],
//       { weekType?: 'current' | 'next' }
//     >({
//       query: ({ weekType = 'current' } = {}) => {
//         const { fromDate, toDate } = getWeeklyDateRange(weekType);

//         return {
//           url: '/transits/week-transit-with-aspect',
//           method: 'GET',
//           params: {
//             fromDate,
//             toDate,
//           },
//         };
//       },
//     }),
//   }),
//   overrideExisting: false,
// });

// export const { useGetWeeklyTransitWithAspectQuery } = weeklyTransitWithAspectApi;

import { apiSlice } from '@/store/api/apiSlice';
import { getWeeklyDateRange } from '@/utils/getWeeklyDateRange';

export interface SignChangeAspect {
  sign: string;
  from: string;
  to: string;
  house: number;
  aspects: {
    aspect: number[];
    aspectSigns: string[];
    houseAspect: number[];
  };
}

export interface NakshatraItem {
  nakshatra: string;
  timestamp: string;
}

export interface PadaItem {
  nakshatra: string;
  pada: string;
  timestamp: string;
}

export interface AstaItem {
  startTime: string;
  endTime: string;
  totalDuration: string;
}

export interface VakriItem {
  retrogradeTime: string;
  progressiveTime: string;
  totalRetrograde: string;
}

export interface WeeklyTransit {
  signChangesAspect: SignChangeAspect[];
  nakshtra: NakshatraItem[];
  pada: PadaItem[];
  asta: AstaItem[];
  vakri: VakriItem[];
}

export interface WeeklyTransitWithAspectResponse {
  planet: string;
  weeklyTransit: WeeklyTransit[];
}

export const weeklyTransitWithAspectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWeeklyTransitWithAspect: builder.query<
      WeeklyTransitWithAspectResponse[],
      { weekType?: 'current' | 'next' }
    >({
      query: ({ weekType = 'current' }: { weekType?: 'current' | 'next' } = {}) => {
        const { fromDate, toDate } = getWeeklyDateRange(weekType);

        return {
          url: '/transits/week-transit-with-aspect',
          method: 'GET',
          params: {
            fromDate,
            toDate,
          },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetWeeklyTransitWithAspectQuery } = weeklyTransitWithAspectApi;
